import { Tooltip, Typography } from '@mui/material';

import { ReactNode } from 'react';

export const TruncatedText = ({ text, maxLength = 50 }: { text?: ReactNode; maxLength?: number }) => {
    if (!text) return <Typography sx={{ fontWeight: 400 }}>-</Typography>;

    const textString = String(text);
    const isTruncated = textString.length > maxLength;

    let displayText = textString;
    if (isTruncated) {
        const truncated = textString.substring(0, maxLength);
        const lastSpaceIndex = truncated.lastIndexOf(' ');

        if (lastSpaceIndex > 0) {
            displayText = truncated.substring(0, lastSpaceIndex) + '...';
        } else {
            displayText = truncated + '...';
        }
    }

    if (isTruncated) {
        return (
            <Tooltip title={textString} placement="top">
                <Typography sx={{ fontWeight: 400 }}>{displayText}</Typography>
            </Tooltip>
        );
    }

    return <Typography sx={{ fontWeight: 400 }}>{displayText}</Typography>;
}; 